import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { BrowserRouter as Router, Switch, Route, useHistory } from "react-router-dom";
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import IconButton from '@mui/material/IconButton';
import Dropdown from 'react-bootstrap/Dropdown';
import NavDropdown from 'react-bootstrap/NavDropdown';
import ConsentDataPreference from "../screens/DashboardA";
import DashboardA from '../screens/DashboardA';
import Home from "../screens/Home";
import PrivacyRequest from '../screens/PrivacyRequest';
import CreateConsentGroup from '../screens/CreateConsentGroup';
import ConsentGroup from "../screens/ManageGroup";
import DataTypeList from '../screens/DatatypeList';
import PurposeList from '../screens/PurposeList';
import Protected from './Protected';
import Profile from '../screens/Profiles';
import CustomizePreferenceCenter from '../screens/CustomizePreferenceCenter';
import TemplateList from "../screens/TemplateList";
import HtmlPage from "../screens/HtmlPage";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch, useSelector } from 'react-redux';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import { faUser, faGear, faRightFromBracket, faPen } from '@fortawesome/free-solid-svg-icons';
import WOW from 'wowjs';
import { switchClients, fetchGroupData, getConsentdetailsByCustomer, getProfileData, logOut } from "../store/actions/CommonAction";
import { Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { InputAdornment, TextField } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import navLogo from '../assets/jioConsentLogo.png'
import Box from '@mui/material/Box';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { accountcircle } from '@material-ui/icons/AccountCircle';
import CircularProgress from '@mui/material/CircularProgress'; // Importing CircularProgress for the loader

import '../style.css/navbar.css'
const columns = [

  {
    headerName: 'Data Used By',
    field: 'dataConsumer',
    width: 150,
    filter: true,
    className: 'gridHead'
  },
  {
    headerName: 'Data Types Used',
    field: 'consentTypes',
    width: 250
  },
  {
    headerName: 'Purpose of Data Used',
    field: 'purpose',
    width: 200,
    renderCell: (params) => params.value.text,
  },
  {
    headerName: 'Consent Duration',
    field: 'consentValidity',
    width: 130,
    renderCell: (params) => params.value.value + " " + params.value.unit
  },
  {
    headerName: 'Consent Creation Date',
    field: 'createTimestamp',
    width: 230,
    type: 'date',
    filter: true,
    valueFormatter: (params) => {
      return `${new Date(params.value)}`;
    },
  },
  // {
  //   headerName: 'Created On',
  //   field:'creationTimestamp',
  //   width: 200,
  //   type:'date',
  //   filter:true,
  //   valueFormatter: (params) => {
  //     return `${new Date(params.value)}`;
  //   },
  // },
  // {
  //   headerName: 'Expiry',
  //   field:'expiry',
  //   width: 200,
  //   type:'date',
  //   filter:true,
  //   valueFormatter: (params) => {
  //     return `${new Date(params.value)}`;
  //   }
  // },
  // {
  //     field: 'cookieCategories',
  //     headerName: 'Cookies',
  //     width: 100,
  //     renderCell: (params) => (
  //       <button onClick={()=>viewCookieDetails(params.row)} className="btn btn-info m-0" style={{backgroundColor:'#660209',  fontSize:'10px'}}>View Cookies</button>
  //     ),
  // },
  // {
  //   headerName: 'Status',
  //   field:'status',
  //   width: 100,
  //   filter: true,
  //   type:'text',
  //   cellClassName: (params) =>
  //   clsx('super-app', {
  //     positive: params.value == "ACTIVE",
  //     negative: params.value == "INACTIVE"
  //   }),
  // }

];

function NavBar() {
  const history = useHistory();
  const [showMenu, setShowMenu] = useState(false);
  const [expandedAccordions, setExpandedAccordions] = useState([]);
  const [groupData, setGroupData] = useState(null);
  const [selectedValue, setSelectedValue] = useState(""); // State to handle selected radio button
  const Logo = useSelector(state => state.common.App_Logo);
  const profileData = useSelector(state => state.common.profileData);
  const clientId = useSelector(state => state.common.clientId)
  const [showConsentSuccess, setShowConsentSuccess] = useState(false);
  const [shouldRenderGrid, setShouldRenderGrid] = useState(false);
  const consentList = useSelector(state => state.common.consentList);
  const [isLoading, setIsLoading] = useState(false); // New state for loader


  const avatarImage = (profileData && (profileData.logo == undefined || profileData.logo == null)) ?
    accountcircle : (profileData && profileData.logo);

  const dispatch = useDispatch();

  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  const toggleSearchField = () => {
    setIsSearchOpen(!isSearchOpen);
  };

  const handleInputChange = async (event) => {
    setSearchQuery(event.target.value);


    // setIsLoading(true);

  };

  const handleShowConsentSuccess = () => {
    //setIsLoading(true);
    setShowConsentSuccess(!showConsentSuccess);
  }

  const closeConsentSuccess = () => {
    // setIsLoading(true);
    setShowConsentSuccess(!showConsentSuccess)
  }


  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      setSearchQuery(event.target.value);
      handleSearch();
    }
  };


  // const handleSearch = async () => {
  //   // Implement your search logic here
  //   try {
  //     await dispatch(getConsentdetailsByCustomer(searchQuery));

  //     setShowConsentSuccess(!showConsentSuccess);
  //     // setIsLoading(false);

  //   } catch (error) {
  //     console.error(error)
  //   }
  // };

  const handleSearch = async () => {
    setIsLoading(true); // Start loading before API call
    try {
      await dispatch(getConsentdetailsByCustomer(searchQuery));
      setShowConsentSuccess(!showConsentSuccess);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false); // Stop loading after API call completes
    }
  };

  const handleClearSearch = () => {
    setSearchQuery('');
    setIsSearchOpen(false); // Optionally close the search field
  };

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpandedAccordions(prev => isExpanded ? [...prev, panel] : prev.filter(p => p !== panel));
  };

  const handleHeaderRadioChange = (clientId, clientSecret, groupId) => (event) => {
    setSelectedValue(clientId, clientSecret, groupId);
    handleSwitch(clientId, clientSecret, groupId);
  };

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSwitch = (clientId, clientSecret, groupId) => {
    // alert("clientId: " + clientId);
    // alert("clientSecret: " + clientSecret);
    // alert("groupId: " + groupId);

    dispatch(switchClients(clientId, clientSecret, groupId));
  }

  const accountId = useSelector(state => state.common.accountIdUAM);
  const groupId = useSelector(state => state.common.groupIdUAM);


  const search = async () => {

    const val = document.getElementById("searchValue").value;
    //setIsLoading(true);
    try {
      await dispatch(getConsentdetailsByCustomer(val));

      setShowConsentSuccess(!showConsentSuccess);
      // setIsLoading(false);

    } catch (error) {
      console.error(error)
    }



  }

  // useEffect(() => {
  //   // const getData = async () => {
  //   //   try {
  //   //     //const data = await fetchGroupData(groupId, accountId);
  //   //     //setGroupData(data);
  //   //     // const clientId = data.clientId;
  //   //     // const clientSecret = data.clientSecret;
  //   //     //const groupId1 = data.groupId;
  //   //     //dispatch(switchClients(clientId, clientSecret, groupId1));
  //   //     //setSelectedValue(clientId,clientSecret, groupId); // Handle the response data here
  //   //   } catch (error) {
  //   //     console.error("Failed to fetch group data:", error);
  //   //   }
  //   // };

  //   getData();
  // }, [groupId, accountId]);

  useEffect(() => {
    if (showConsentSuccess) {
      const timer = setTimeout(() => {
        setShouldRenderGrid(true);
      }, 100); // Adjust the delay value as needed
      // Clear the timer if the component unmounts or the effect re-runs,
      // avoiding a "state update on an unmounted component" warning.
      return () => clearTimeout(timer);
    } else {
      setShouldRenderGrid(false);
    }
  }, [showConsentSuccess])

  const handleLogout = async () => {
    await dispatch(logOut());
    // await dispatch(hideNavbar(false))
    //localStorage.clear();
    history.push("/");
    window.location.reload();
    toast.success('You have been successfully logged out');
  }


  const signOut = async () => {

  };



  const callAPI = async () => {
    try {
      await dispatch(getProfileData(clientId))
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    const wow = new WOW.WOW({
      live: false,
    });
    wow.init();
  }, []);

  return (
    <>
      {showConsentSuccess &&
        <div class="modalLikeBox" style={{ 
          width: '80%', 
          maxWidth: '900px', // Sets a max width for large screens
          marginLeft: 'auto', 
          marginRight: 'auto', 
          marginTop: '0%', 
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: '#fff',
          borderRadius: '8px',
          // boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
          overflow: 'hidden',
          zIndex: 1000 // Ensures it appears above other elements
        }} >
          <div class="modalLikeHead" >
            <div class="modalLikeTitle" >
              Consent List
            </div>
          </div>

          <div class="modalLikeBody" style={{height:'70vh'}}>
          {isLoading ? (
              <div className="text-center">
                <CircularProgress /> {/* Loader inside modal if still loading */}
              </div>
            ) : (
            <Box
              sx={{
                width: '100%',
                height: '100%',
                //height: '60vh', // Set a max height to make it scrollable
                overflowY: 'auto',
                '& .super-app-theme--cell': {
                  backgroundColor: 'rgba(224, 183, 60, 0.55)',
                  color: '#fff',
                },
                '& .super-app.negative': {
                  backgroundColor: '#f5222d',
                  color: '#fff',
                },
                '& .super-app.positive': {
                  backgroundColor: '#28a745',
                  color: '#fff',
                },
              }}
            >
              <div style={{ height: '100%', width: '100%', overflowY: 'hidden' }}>

                {/* {isLoading ? (
                <div class="text-center">
                  <img src={loader} style={{height:'100px', textAlign:'center'}}></img><br></br>
                  <b>Loading...</b>
                </div>
              ) : ( */}
                <DataGrid
                  rows={consentList}
                  columns={columns}
                  getRowId={(row) => row.consentId}
                  initialState={{
                    pagination: {
                      paginationModel: { page: 0, pageSize: 10 },
                    }
                  }}
                  pageSizeOptions={[5, 10]}


                  className='table dashboard-table dashboard-card'

                />
                {/* )} */}

              </div>
              {consentList && consentList.length == 0 &&
              <h6 style={{ color: '#777777' }}>No Consents Available</h6>
            }
            </Box>
)}


            
          </div>
          <div class="modalLikeFooter" >
            {/* <MaterialButton variant="contained" color="primary"  onClick={handleClose}>Close</MaterialButton> */}
            <button onClick={closeConsentSuccess} className="btn btn-outline-primary " >Ok</button>
          </div>
        </div>}
      <Router>
        <header className='header'>
          <Navbar expand="xl">
            <Container>
              <a className={showMenu ? 'hamburger active' : 'hamburger'} href="#" onClick={() => setShowMenu(!showMenu)}><span></span></a>
              <Navbar.Brand href="/home">
                <img src={navLogo} alt="Logo" style={{ width: '200px' }} />
              </Navbar.Brand>
              <Navbar.Collapse id="navbarNav" className={showMenu ? 'show' : ''}>
                <Nav className="mx-auto" as="ul">
                  <Nav.Item as="li">
                    <NavLink to="/home" className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}>Dashboard</NavLink>
                  </Nav.Item>
                  {/* <Nav.Item as="li">
                  <NavLink to="/dsr" className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}>DSR</NavLink>
                </Nav.Item> */}
                  <Nav.Item as="li">
                    <NavLink to="/createConsentGroup/:page" className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}>Consent Group</NavLink>
                  </Nav.Item>
                  {/* <Nav.Item as="li">
                  <NavLink to="/metareports" className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}>Meta Reports</NavLink>
                </Nav.Item> */}
                  <NavDropdown title="Manage">
                    <div className='sub-menu'>
                      <div className='container p-0 px-lg-3'>
                        <div className='row m-0'>
                          <div className='col-12 p-0'>
                            <Nav.Item as="li">
                              <NavLink to="/datatype" className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}>Data Type</NavLink>
                            </Nav.Item>
                            <Nav.Item as="li">
                              <NavLink to="/purpose" className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}>Purpose</NavLink>
                            </Nav.Item>
                            <Nav.Item as="li">
                              <NavLink to="/templatelist/:from" className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}>Template</NavLink>
                            </Nav.Item>
                            <Nav.Item as="li">
                              <NavLink to="/consentgroup" className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}>Consent Group</NavLink>
                            </Nav.Item>


                          </div>
                        </div>
                      </div>
                    </div>
                  </NavDropdown>
                  <Nav.Item as="li">
                    <NavLink to="/customizePreferenceCenter" className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}>Customize Preference Center</NavLink>
                  </Nav.Item>
                </Nav>
              </Navbar.Collapse>
              <div className="d-flex align-items-center">
                <IconButton aria-label="search" className='me-1' onClick={toggleSearchField}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.004 2.00001C11.3023 2.0014 12.5746 2.36381 13.6788 3.04676C14.7829 3.7297 15.6754 4.70625 16.2564 5.86727C16.8374 7.02829 17.0841 8.32801 16.9689 9.62118C16.8537 10.9143 16.3811 12.15 15.604 13.19L21.714 19.29C21.8078 19.383 21.8822 19.4936 21.9329 19.6154C21.9837 19.7373 22.0098 19.868 22.0098 20C22.0098 20.132 21.9837 20.2627 21.9329 20.3846C21.8822 20.5064 21.8078 20.617 21.714 20.71C21.6211 20.8037 21.5105 20.8781 21.3886 20.9289C21.2667 20.9797 21.136 21.0058 21.004 21.0058C20.872 21.0058 20.7413 20.9797 20.6195 20.9289C20.4976 20.8781 20.387 20.8037 20.294 20.71L14.194 14.6C13.3064 15.2658 12.2731 15.7109 11.1796 15.8989C10.086 16.0868 8.96347 16.0121 7.90447 15.6808C6.84548 15.3496 5.88039 14.7714 5.0888 13.9939C4.29721 13.2163 3.70181 12.2617 3.35168 11.2088C3.00154 10.156 2.90673 9.03491 3.07504 7.93816C3.24336 6.84142 3.66998 5.8004 4.31973 4.90095C4.96948 4.0015 5.82374 3.2694 6.81206 2.76502C7.80038 2.26064 8.89444 1.99842 10.004 2.00001ZM10.004 14C10.9929 14 11.9596 13.7068 12.7819 13.1574C13.6041 12.6079 14.245 11.8271 14.6234 10.9134C15.0019 9.99979 15.1009 8.99446 14.908 8.02456C14.715 7.05465 14.2388 6.16374 13.5396 5.46447C12.8403 4.76521 11.9494 4.28901 10.9795 4.09608C10.0096 3.90315 9.00424 4.00217 8.09061 4.38061C7.17698 4.75905 6.39609 5.39991 5.84668 6.22216C5.29727 7.0444 5.00403 8.0111 5.00403 9.00001C5.00403 9.65662 5.13336 10.3068 5.38463 10.9134C5.6359 11.5201 6.0042 12.0712 6.46849 12.5355C6.93279 12.9998 7.48398 13.3681 8.09061 13.6194C8.69724 13.8707 9.34742 14 10.004 14Z" fill="white" />
                  </svg>
                </IconButton>

                {/* <div className="dropdown profile">
                <Dropdown>
                  <Dropdown.Toggle variant="success">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.00001 11C7.23266 10.996 7.46412 10.9658 7.69001 10.91C7.03406 10.0858 6.62955 9.09002 6.52491 8.04186C6.42027 6.99371 6.61994 5.93761 7.10001 5H7.00001C6.20436 5 5.4413 5.31607 4.87869 5.87868C4.31608 6.44129 4.00001 7.20435 4.00001 8C4.00001 8.79565 4.31608 9.55871 4.87869 10.1213C5.4413 10.6839 6.20436 11 7.00001 11ZM12 11C12.6922 11 13.3689 10.7947 13.9445 10.4101C14.5201 10.0256 14.9687 9.47893 15.2336 8.83939C15.4985 8.19985 15.5678 7.49612 15.4328 6.81719C15.2977 6.13825 14.9644 5.51461 14.4749 5.02513C13.9854 4.53564 13.3618 4.2023 12.6828 4.06725C12.0039 3.9322 11.3002 4.00152 10.6606 4.26642C10.0211 4.53133 9.47445 4.97993 9.08987 5.55551C8.70528 6.13108 8.50001 6.80777 8.50001 7.5C8.50001 8.42826 8.86876 9.3185 9.52514 9.97487C10.1815 10.6313 11.0718 11 12 11ZM17 11C17.7957 11 18.5587 10.6839 19.1213 10.1213C19.6839 9.55871 20 8.79565 20 8C20 7.20435 19.6839 6.44129 19.1213 5.87868C18.5587 5.31607 17.7957 5 17 5H16.9C17.378 5.93641 17.5765 6.99056 17.4719 8.03669C17.3673 9.08282 16.964 10.0768 16.31 10.9C16.5355 10.9592 16.767 10.9927 17 11ZM12 12C10.4087 12 8.88259 12.6321 7.75737 13.7574C6.63215 14.8826 6.00001 16.4087 6.00001 18C6.00001 18.5304 6.21072 19.0391 6.5858 19.4142C6.96087 19.7893 7.46958 20 8.00001 20H16C16.5304 20 17.0392 19.7893 17.4142 19.4142C17.7893 19.0391 18 18.5304 18 18C18 16.4087 17.3679 14.8826 16.2427 13.7574C15.1174 12.6321 13.5913 12 12 12ZM17.31 12C18.1579 12.7524 18.8362 13.6765 19.2999 14.7109C19.7637 15.7453 20.0023 16.8664 20 18C19.9948 18.3378 19.9478 18.6737 19.86 19H20C20.5304 19 21.0392 18.7893 21.4142 18.4142C21.7893 18.0391 22 17.5304 22 17C22.0025 15.7259 21.5184 14.499 20.6468 13.5697C19.7752 12.6404 18.5816 12.079 17.31 12ZM6.69001 12C5.41838 12.079 4.22487 12.6404 3.35322 13.5697C2.48158 14.499 1.99756 15.7259 2.00001 17C2.00001 17.5304 2.21072 18.0391 2.5858 18.4142C2.96087 18.7893 3.46958 19 4.00001 19H4.14001C4.05222 18.6737 4.00519 18.3378 4.00001 18C3.99769 16.8664 4.23632 15.7453 4.70007 14.7109C5.16383 13.6765 5.84212 12.7524 6.69001 12Z"
                        fill="white"
                      />
 
                    </svg>
                  </Dropdown.Toggle>
                  <Dropdown.Menu align="end" id="style-3" className="ac-menu">
                    <h4 className="drop-label">User Group</h4>
                    {groupData ? (
                      <Accordion
                        expanded={expandedAccordions.includes("panel1")}
                        onChange={handleAccordionChange("panel1")}
                      >
                        <AccordionSummary>
                          <FormControlLabel
                            control={
                              <Radio
                                checked={selectedValue === groupData.clientId}
                                onChange={handleHeaderRadioChange(groupData.clientId, groupData.clientSecret, groupData.groupId)}
                                value={groupData.clientId}
                              />
                            }
                            // label={groupData.groupName}
                            // sx={{ marginLeft: 2 }}
                            label={<Typography sx={{ ml: 1}}>{groupData.groupName}</Typography>}
                          />
                        </AccordionSummary>
                        <AccordionDetails>
                          {groupData.children && groupData.children.length > 0 ? (
                            <ul style={{ listStyleType: "none", paddingLeft: 0 }}>
                              {groupData.children.map((subGroup, subIndex) => (
                                <li key={subIndex}>
                                  <Accordion
                                    expanded={expandedAccordions.includes(subGroup.clientId)}
                                    onChange={handleAccordionChange(subGroup.clientId , subGroup.clientSecret, subGroup.groupId)}
                                  >
                                    <AccordionSummary>
                                      <FormControlLabel
                                        control={
                                          <Radio
                                            checked={selectedValue === subGroup.clientId}
                                            onChange={handleHeaderRadioChange(subGroup.clientId , subGroup.clientSecret, subGroup.groupId)}
                                            value={subGroup.clientId}
                                          />
                                        }
                                        // label={subGroup.groupName}
                                        // sx={{ marginLeft: 2 }}
                                        label={<Typography sx={{ ml: 1}}>{subGroup.groupName}</Typography>}
                                      />
                                    </AccordionSummary>
                                    <AccordionDetails>
                                      {subGroup.children && subGroup.children.length > 0 ? (
                                        <ul style={{ listStyleType: "none", paddingLeft: 0 }}>
                                          {subGroup.children.map((nestedGroup, nestedIndex) => (
                                            <li key={nestedIndex}>
                                             
 
 
                                              <Accordion
                                    expanded={expandedAccordions.includes(nestedGroup.clientId)}
                                    onChange={handleAccordionChange(nestedGroup.clientId , nestedGroup.clientSecret, nestedGroup.groupId)}
                                  >
                                    <AccordionSummary>
                                      <FormControlLabel
                                        control={
                                          <Radio
                                            checked={selectedValue === nestedGroup.clientId}
                                            onChange={handleHeaderRadioChange(nestedGroup.clientId , nestedGroup.clientSecret, nestedGroup.groupId)}
                                            value={nestedGroup.clientId}
                                          />
                                        }
                                        label={<Typography sx={{ ml: 1}}>{nestedGroup.groupName}</Typography>}
                                      />
                                    </AccordionSummary>
                                    <AccordionDetails>
                                      {nestedGroup.children && nestedGroup.children.length > 0 ? (
                                        <ul style={{ listStyleType: "none", paddingLeft: 0 }}>
                                          {nestedGroup.children.map((nested2ndGroup, nested2ndIndex) => (
                                            <li key={nested2ndIndex}>
                                              <FormControlLabel
                                                control={
                                                  <Radio
                                                    checked={selectedValue === nested2ndGroup.clientId}
                                                    onChange={handleHeaderRadioChange(nested2ndGroup.clientId , nested2ndGroup.clientSecret, nested2ndGroup.groupId)}
                                                    value={nested2ndGroup.clientId}
                                                  />
                                                }
                                                // label={nested2ndGroup.groupName}
                                                label={<Typography sx={{ ml: 1}}>{nested2ndGroup.groupName}</Typography>}
                                              />
                                            </li>
                                          ))}
                                        </ul>
                                      ) : (
                                        <div>No subgroups available</div>
                                      )}
                                    </AccordionDetails>
                                  </Accordion>
                                            </li>
                                          ))}
                                        </ul>
                                      ) : (
                                        <div>No subgroups available</div>
                                      )}
                                    </AccordionDetails>
                                  </Accordion>
                                </li>
                              ))}
                            </ul>
                          ) : (
                            <div>No subgroups available</div>
                          )}
                        </AccordionDetails>
                      </Accordion>
                    ) : (
                      <div>No groups available</div>
                    )}
                  </Dropdown.Menu>
                </Dropdown>
              </div> */}

                {/* <IconButton aria-label="theme" className='me-1'>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.50001 11C7.32606 11.0603 6.21619 11.5538 5.38499 12.385C4.55379 13.2162 4.06032 14.326 4.00001 15.5C4.00001 18.31 3.32001 19.26 3.26001 19.32C3.13217 19.4612 3.04731 19.636 3.01543 19.8237C2.98354 20.0115 3.00594 20.2045 3.08001 20.38C3.15503 20.5626 3.28242 20.7189 3.44614 20.8293C3.60986 20.9396 3.80258 20.999 4.00001 21C8.19001 21 13 20.38 13 15.5C12.9397 14.326 12.4462 13.2162 11.615 12.385C10.7838 11.5538 9.67395 11.0603 8.50001 11ZM20.12 3.87998C19.5575 3.31818 18.795 3.00262 18 3.00262C17.205 3.00262 16.4425 3.31818 15.88 3.87998L10.43 9.31998C11.4061 9.67418 12.2911 10.2411 13.021 10.9796C13.7509 11.7182 14.3073 12.6098 14.65 13.59L20.12 8.11998C20.6818 7.55748 20.9974 6.79499 20.9974 5.99998C20.9974 5.20498 20.6818 4.44249 20.12 3.87998Z" fill="white"/>
                </svg>
              </IconButton> */}
                {/* <IconButton aria-label="notification" className='me-2'>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21 16H20V10C20 7.87827 19.1571 5.84344 17.6569 4.34315C16.1566 2.84285 14.1217 2 12 2C9.87827 2 7.84344 2.84285 6.34315 4.34315C4.84285 5.84344 4 7.87827 4 10V16H3C2.73478 16 2.48043 16.1054 2.29289 16.2929C2.10536 16.4804 2 16.7348 2 17C2 17.2652 2.10536 17.5196 2.29289 17.7071C2.48043 17.8946 2.73478 18 3 18H21C21.2652 18 21.5196 17.8946 21.7071 17.7071C21.8946 17.5196 22 17.2652 22 17C22 16.7348 21.8946 16.4804 21.7071 16.2929C21.5196 16.1054 21.2652 16 21 16ZM12 22C12.7956 22 13.5587 21.6839 14.1213 21.1213C14.6839 20.5587 15 19.7956 15 19H9C9 19.7956 9.31607 20.5587 9.87868 21.1213C10.4413 21.6839 11.2044 22 12 22Z" fill="white"/>
                </svg>
              </IconButton> */}

                <div className="dropdown profile">
                  <Dropdown>
                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                      {/* <img src="Img/user.png" alt="User" /> */}
                      <img src={avatarImage} class="img-thumbnail profile-nav" alt="Logo" style={{ height: '45px', borderRadius: '1.375rem' }}></img>
                    </Dropdown.Toggle>
                    <Dropdown.Menu align="end" as="ul">
                      <li>
                        <Dropdown.Item href="/profile"><FontAwesomeIcon icon={faUser} /> Profile</Dropdown.Item>
                      </li>
                      {/* <li>
                      <Dropdown.Item href="#/"><FontAwesomeIcon icon={faGear} /> Setting</Dropdown.Item>
                    </li> */}
                      {/* <li >
                      <Dropdown.Item href="/customizePreferenceCenter"><FontAwesomeIcon icon={faPen}  /> Customized Preference Center</Dropdown.Item>
                    </li> */}
                      <li>
                        <Dropdown.Item onClick={handleLogout} href="/login"><FontAwesomeIcon icon={faRightFromBracket} /> Logout</Dropdown.Item>
                      </li>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </Container>
          </Navbar>
          {isSearchOpen && (
            <div style={{ display: 'flex', alignItems: 'center', marginLeft: '10px' }}>
              <TextField
                id="search-input"
                type="text"
                value={searchQuery}
                onChange={handleInputChange}
                onKeyPress={handleKeyPress}
                placeholder="Search consent by customer id.."
                size="small"
                class="custom-search-box"

                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="search"
                        onClick={handleSearch}
                      >
                        <FontAwesomeIcon icon={faSearch} style={{ fontSize: '12px', padding: '0px' }} />
                      </IconButton>
                      <IconButton
                        aria-label="clear"
                        onClick={handleClearSearch}
                      >
                        <FontAwesomeIcon icon={faTimes} style={{ fontSize: '12px', padding: '0px' }} />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div>
          )}
        </header>

        <Switch>
          <Route exact key='102' path="/dashboardA"> <Protected Cmp={DashboardA} /></Route>
          <Route exact key='12' path="/home"> <Protected Cmp={Home} /> </Route>
          <Route exact key='101' path="/consentgroup"> <Protected Cmp={ConsentGroup} /></Route>
          <Route exact key='103' path="/datatype"> <Protected Cmp={DataTypeList} /></Route>
          <Route exact key='104' path="/purpose"> <Protected Cmp={PurposeList} /></Route>
          <Route exact key='31' path="/templatelist/:from"> <Protected Cmp={TemplateList} /></Route>
          <Route key='44' path="/template"> <Protected Cmp={HtmlPage} /></Route>
          <Route key='45' path="/profile"> <Protected Cmp={Profile} /></Route>
          <Route key='45' path="/customizePreferenceCenter"> <Protected Cmp={CustomizePreferenceCenter} /></Route>
          <Route exact key='21' path="/createConsentGroup/:page"> <Protected Cmp={CreateConsentGroup} /> </Route>
        </Switch>
      </Router>

    </>
  );
}

export default NavBar;
